import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormErrorsComponent } from '../../../shared/components/form-errors/form-errors.component';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { ToastMessageService } from '../../../core/services/toast-message.service';
import { StorageService } from '../../../core/services/storage.service';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, FormErrorsComponent, ButtonModule, RouterModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  loginForm!: FormGroup;

  loadingSubmit: boolean = false;

  constructor(private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private toasterService: ToastMessageService,
    private storageService: StorageService) {

  }
  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]]
    });
  }

  submit() {
    if (this.loginForm.valid) {
      this.loadingSubmit = true;
      this.authService.login(this.loginForm.value).subscribe({
        next: (resp: any) => {
          this.loadingSubmit = true;
          this.toasterService.toastOnSuccess('Success', "You logged in successfully");
          this.storageService.setToken(resp?.data?.token);
          this.storageService.setUserRole(resp?.data?.user?.role);
          this.storageService.setUserData(resp?.data?.user);
          // this.storageService.userPermissions = resp.data.permissions?.permissions || {};
          this.goToTargetRoute(resp?.data?.user?.role);

        }, error: error => {
          this.loadingSubmit = false;

        }
      })
    } else {
      this.loginForm.markAllAsTouched();
    }
  }
  goToTargetRoute(role: string) {
    switch (role) {
      case "operation": {
        this.router.navigate(['/clients']);
        break;
      }
      case "finance": {
        this.router.navigate(['/payments']);
        break;
      }
      case "sales_marketing": {
        this.router.navigate(['/home']);
        break;
      }
      default: {
        this.router.navigate(['/clients']);
        break;
      }
    }
  }
}
